import { FunctionComponent, MouseEvent } from "react";
import styles from "./PurchaseButton.module.css";
import { LabelPairedLoaderMdRegularIcon } from "@deriv/quill-icons";

export type PurchaseButtonType = {
  className?: string;
  label?: string;
  title?: string;
  value?: string;
  showContent?: boolean;

  /** Variant props */
  state?: "default" | "loading" | "disabled";
  type?: "buy" | "sell";
  
  /** Event handlers */
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

export const PurchaseButton: FunctionComponent<PurchaseButtonType> = ({
  className = "",
  state = "default",
  type = "buy",
  label = "Payout",
  title = "Title",
  value = "Value",
  showContent = true,
  onClick,
}) => {
  return (
    <div
      className={[
        styles.root,
        className,
        state === "default" ? "quill-ui-next-pointer" : ""
      ].join(" ")}
      data-state={state}
      data-type={type}
      role="button"
      tabIndex={state === "loading" || state === "disabled" ? -1 : 0}
      onClick={(e) => state !== "loading" && state !== "disabled" && onClick?.(e)}
    >
      {state === "loading" && (
        <div className={[styles.iconLoading, "quill-ui-next-spinner"].join(" ")}>
          <div className={styles.icon}>
            <LabelPairedLoaderMdRegularIcon fill="var(--component-button-label-color-buy-primary)"/>
          </div>
        </div>
      )}
      {!!showContent && (
        <div className={styles.containerContent}>
          <div className={styles.title}>
            <div className={styles.label}>{title}</div>
          </div>
          <div className={styles.description}>
            <div className={styles.details}>{label}</div>
            <div className={styles.value}>{value}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PurchaseButton;
